import { render, staticRenderFns } from "./InvestorBank.vue?vue&type=template&id=33fb9655&"
import script from "./InvestorBank.vue?vue&type=script&lang=js&"
export * from "./InvestorBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports